import ellipsisImage from "../../../common/images/ellipsis.svg";
import schoolImage from "../../../common/images/school.svg";
import eyeImage from "../../../common/images/eye-blue.svg";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import editImage from "../../../common/images/edit.svg";
import {
    setIsEditCertificateModalOpen,
    setSelectedCertificateId,
} from "../../../modals/EditCertificateModal/EditCertificateModalSlice";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { NavigateFunction } from "react-router";
import { Dispatch } from "redux";
import React from "react";
import { getValidityPeriodDisplay } from "../../../common/utils/getValidityPeriodDisplay";
import {
    setIsLeftTagModalOpenIndex,
    setIsRightTagModalOpenIndex,
} from "../EmployeeDetailSlice";
import { InfoCardProps } from "@hatch-digital-nl/abs-storybook/legacy";
import { openFileInNewTab } from "../../../common/utils/openFileInNewTab";

interface ModalData {
    ref: React.RefObject<HTMLDivElement | null>;
    openIndex: number;
    setOpenModalIndex: (index: number) => void;
}

export const mapCertificatesToInfoCards = (
    certificates: CertificateInterface[],
    modal: ModalData,
    navigate: NavigateFunction,
    dispatch: Dispatch,
    isLeftTagModalOpen: number,
    isRightTagModalOpen: number,
    ellipsisWhiteImage: string,
): InfoCardProps[] => {
    return certificates.map((certificate, index) => {
        const { qualification } = certificate;
        const validityPeriod = getValidityPeriodDisplay({
            expiresAt: certificate.expires_at,
        });

        return {
            leftTagNames: qualification.function_group.map(
                (functionGroup) => functionGroup.name,
            ),
            rightTagNames: qualification.qualification_standards.map(
                (qualificationStandard) => qualificationStandard.name,
            ),
            isLeftTagOpen: index === isLeftTagModalOpen,
            isRightTagOpen: index === isRightTagModalOpen,
            onClickLeftTag: () => dispatch(setIsLeftTagModalOpenIndex(index)),
            onClickRightTag: () => dispatch(setIsRightTagModalOpenIndex(index)),
            leftTagRef: modal.ref,
            rightTagRef: modal.ref,
            title: qualification.name,
            description: qualification.qualification_standards,
            image: qualification.image_url,
            date: qualification.created_at,
            validityPeriod: {
                text: validityPeriod.text,
                icon: validityPeriod.icon,
            },
            backgroundColor: index % 2 === 0 ? "#FFFBF9" : "#FFF",
            modalButton: {
                modalRef: modal.ref,
                handleClick: () => modal.setOpenModalIndex(index),
                isOpen: index === modal.openIndex,
                iconButtonIconUrl: ellipsisImage ?? "",
                iconButtonBackgroundColor: "#F3F4F6",
                onOpenIconButtonUrl: ellipsisWhiteImage,
                onOpenIconButtonBackgroundColor: "#1D2D58",
                actionData: [
                    {
                        iconUrl: schoolImage,
                        onClick: () =>
                            navigate(
                                RouteEnum.QUALIFICATIONS +
                                    "/" +
                                    qualification.id,
                            ),
                        title: "Bekijken",
                    },
                    ...(certificate &&
                    certificate.certificate_file &&
                    certificate.certificate_file.file_url &&
                    certificate.certificate_file.file_name
                        ? [
                              {
                                  iconUrl: eyeImage,
                                  onClick: () =>
                                      openFileInNewTab(
                                          certificate.certificate_file.file_url,
                                      ),
                                  title: "Bekijk certificaat",
                              },
                          ]
                        : []),
                    ...(!certificate.approved &&
                    (certificate.expires_at === null ||
                        new Date(certificate.expires_at) >= new Date())
                        ? [
                              {
                                  iconUrl: editImage,
                                  onClick: () => {
                                      dispatch(
                                          setIsEditCertificateModalOpen(true),
                                      );
                                      dispatch(
                                          setSelectedCertificateId(
                                              certificate.id,
                                          ),
                                      );
                                  },
                                  title: "Bewerken",
                              },
                          ]
                        : []),
                ],
            },
        };
    });
};
